import React from 'react';
import LogoMakerNavPortal from '@fiverr-private/header/entries/LogoMakerNavPortal';
import { CHOOSE_VARIATION } from '../propTypes';
import Navigation from '../Navigation';
import VariationsColumn from '../VariationsColumn';
import SamplesColumn from '../SamplesColumn';
import VariationsCarousel from '../VariationsCarousel';
import { ChooseVariationContext } from '../Context';
import EducationModal from '../EducationModal';
import MobileChooseVariation from '../MobileChooseVariation';
import MobileNavigation from '../Navigation/MobileNavigation';
import { FavoritesContextProvider } from '../FavoritesContext';
import useChooseVariation from './hooks/useChooseVariation';

import './style.scss';

const ChooseVariation = ({
    context: { brandName, userId, slogan, projectId, briefId, selectedVariation: initialSelectedVariationId, source },
    projectData: { variations: suggestedVariations = [], ...project },
    httpRequest = {},
    sellerData = {},
    userSavedProject = null,
    ordersVariations = [],
    draftsVariations = [],
    currentUser,
    briefData = {},
    availablePackages,
    hasFreeVariations,
    simplifiedPackageType,
}) => {
    const {
        isTouch,
        isMobile,
        uaIsMobile,
        isDesktopSize,
        isTabletSize,
        isPurchasing,
        projectIsSaved,
        isProjectOwner,
        mainSampleRendered,
        handlePurchase,
        changeSavedProject,
        setMainSampleRendered,
        contextValue,
    } = useChooseVariation({
        userId,
        projectId,
        briefId,
        brandName,
        slogan,
        draftsVariations,
        ordersVariations,
        suggestedVariations,
        project,
        sellerData,
        briefData,
        simplifiedPackageType,
        currentUser,
        userSavedProject,
        selectedVariationId: initialSelectedVariationId,
        availablePackages,
        hasFreeVariations,
        httpRequest,
        source,
    });

    return (
        <ChooseVariationContext.Provider value={contextValue}>
            {isDesktopSize && (
                <LogoMakerNavPortal>
                    <Navigation isDisabled={!mainSampleRendered} isLoading={isPurchasing} onPurchase={handlePurchase} />
                </LogoMakerNavPortal>
            )}
            <FavoritesContextProvider value={userSavedProject}>
                <div className="makers-choose-variation">
                    {!isTouch && <EducationModal />}
                    <div className="app-wrapper">
                        {isMobile ? (
                            <MobileChooseVariation
                                projectIsSaved={projectIsSaved}
                                isProjectOwner={isProjectOwner}
                                seller={sellerData}
                                isMobile={uaIsMobile}
                                onSavedProjectChange={changeSavedProject}
                                onMainSampleRendered={() => setMainSampleRendered(true)}
                            />
                        ) : (
                            <>
                                <div className="grid-12">
                                    <VariationsColumn
                                        isMobileOrTabletSize={!isDesktopSize}
                                        seller={sellerData}
                                        isProjectOwner={isProjectOwner}
                                    />
                                    {isTabletSize && (
                                        <VariationsCarousel
                                            className="variations-sticky"
                                            isProjectOwner={isProjectOwner}
                                        />
                                    )}
                                    <SamplesColumn
                                        onMainSampleTextFieldsRender={() => setMainSampleRendered(true)}
                                        isLoading={isPurchasing}
                                        onPurchase={handlePurchase}
                                    />
                                </div>
                            </>
                        )}
                        {(isMobile || isTabletSize) && (
                            <MobileNavigation
                                isDisabled={!mainSampleRendered}
                                isLoading={isPurchasing}
                                onPurchase={handlePurchase}
                            />
                        )}
                    </div>
                </div>
            </FavoritesContextProvider>
        </ChooseVariationContext.Provider>
    );
};

ChooseVariation.propTypes = CHOOSE_VARIATION;

export default ChooseVariation;
